import BaseService from '@/services/BaseService'

class Auth {


    constructor() {
        this.httpService = new BaseService();
        this.controller = 'auth'
    }

    login(payload) {
        let settings = {
            baseURL: `${this.httpService.baseUrl}/${this.controller}/login`,
            method: 'POST',
            data: payload
        }
        console.log('login')
        return this.httpService.service(settings)
    }

    authorized() {
        let settings = {
            baseURL: `${this.httpService.baseUrl}/${this.controller}/authorize`,
            method: 'HEAD'
        }
        console.log('authorized')
        return this.httpService.service(settings)
    }

    registration(payload) {
        let settings = {
            baseURL: `${this.httpService.baseUrl}/${this.controller}/registration`,
            method: 'POST',
            data: payload
        }
        console.log('accounts')
        return this.httpService.service(settings)
    }

    forgotPassword(payload) {
        let settings = {
            baseURL: `${this.httpService.baseUrl}/${this.controller}/forgot-password`,
            method: 'POST',
            data: payload
        }
        console.log('forgotpassword')
        return this.httpService.service(settings)
    }

    resetPassword(payload) {
        let settings = {
            baseURL: `${this.httpService.baseUrl}/${this.controller}/reset-password`,
            method: 'POST',
            data: payload
        }
        console.log('resetpassword')
        return this.httpService.service(settings)
    }
}

export default Auth